import React from 'react';
import styled from 'styled-components';
import { ChromePicker } from 'react-color';

const Wrapper = styled.div`
    margin: 5px 0px 0px 10px;
`;

const DefaultGradientSwatch = styled.div`
    position: relative;
    margin-top: -35px;
    background:
      linear-gradient(217deg, rgba(255,0,0,.8), rgba(255,0,0,0) 70.71%),
      linear-gradient(127deg, rgba(0,255,0,.8), rgba(0,255,0,0) 70.71%),
      linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%);
    width: 35px;
    height: 35px;
`;

const PickerSwatch = styled.div`
    padding: 5px;
    background: #fff;
    border-radius: 1px;
    box-shadow: 0 0 0 1px rgba(0,0,0,.1);
    display: inline-block;
    cursor: pointer
`;

const PickerPopover = styled.div`
    position: absolute;
    z-index: 2;
`;

const PickerCover = styled.div`
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
`;

const PickerColor = styled.div`
    width: 35px;
    height: 35px;
    border-radius: 2px;
    background: ${props => props.value};
    box-shadow: 1px rgba(0,0,0,.1);
`;

class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayColorPicker: false
        };
    }

  handleClick = () => {
      this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
      this.setState({ displayColorPicker: false });
  };

  handleChange = (color) => {
      this.props.updateColorPicker(color.hex);
  };

  render() {
      return (
          <Wrapper>
              <PickerSwatch onClick={ this.handleClick }>
                  <PickerColor value={this.props.color} />
                  { this.props.color ? null : <DefaultGradientSwatch /> }
              </PickerSwatch>
              { this.state.displayColorPicker ? <PickerPopover>
                  <PickerCover onClick={ this.handleClose }/>
                  <ChromePicker disableAlpha color={ this.props.color } onChange={ this.handleChange } />
              </PickerPopover> : null }

          </Wrapper>
      );
  }
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/ColorPicker.js